import { UrgencyType } from 'src/app/job/constants/job-detail.constants';
import { JobTypeEnum } from './Enums';
import { SelectedTeamResult } from 'src/app/job/components/job-dashboard/team-selection/selected-team-result.model';

export class AdvancedSearch {
  static instance: AdvancedSearch;
  isApply: boolean;
  selectedJobIdentification: string;
  posted_Start: Date;
  posted_End: Date;
  deadLine_Start: string;
  deadLine_end: string;
  selectedJobType: Array<{ id: number; text: string }>;
  selectedUrgency: { id: number; text: string };
  selectedStatus: Array<{ id: number; text: string }>;
  serviceTypesChips: Array<{ id: number; text: string }>;
  tradeesChips: Array<{ id: number; text: string }>;
  propertyChips: Array<{ id: number; text: string }>;
  isSnoozedJob:boolean;
  scrolledTop: number;
  public urgencyTypes: Array<{ id: number; text: string }> = [
    { id: null, text: 'Any' },
    { id: UrgencyType.Emergency, text: UrgencyType[UrgencyType.Emergency] },
    { id: UrgencyType.Urgent, text: UrgencyType[UrgencyType.Urgent] },
    { id: UrgencyType.Normal, text: 'Non-Urgent' },
  ];
  public jobTypes: Array<{ id: number; text: string }> = [
    { id: null, text: 'Any' },
    { id: JobTypeEnum.OpenJob, text: 'Open' },
    { id: JobTypeEnum.closedJob, text: 'Closed' },
    { id: JobTypeEnum.reccurringJob, text: 'Recurring' },
  ];
  public closedJobStatus: Array<{ id: number; text: string }> = [
    { id: 8, text: 'Completed' },
    { id: 21, text: 'Inactive' },
    { id: 22, text: 'Rejected Jobs' },
  ];
  public openJobStatus: Array<{ id: number; text: string }> = [
    { id: 11, text: 'Tenant Posted' },
    { id: 63, text: 'Trade Posted' },
    { id: 13, text: 'Owner Approved' },
    { id: 10, text: 'Quotes Available' },
    { id: 16, text: 'Overdue' },
    { id: 7, text: 'Invoice Review' },
    { id: 37, text: 'Variation Jobs' },
    { id: 20, text: 'Draft Jobs' },
    { id: 30, text: 'Owner Rejected' },
    { id: 12, text: 'Pending Owner Approval' },
    { id: 29, text: 'Quotes Pending' },
    { id: 4, text: 'Unscheduled' },
    { id: 26, text: 'Pending Schedule' },
    { id: 39, text: 'Pending Invoice' },
    { id: 19, text: 'Scheduled' },
    { id: 5, text: 'In Progress' },
    { id: 32, text: 'External / Strata' },
    // { id: 64, text: 'Snoozed' },
  ];
  public statuses: Array<{ id: number; text: string }> = [];
  public pageNumber: number;
  public pageSize: number;
  public selectedTeamUsers: SelectedTeamResult[] = [];
  private constructor() {
    this.isApply = false;
    this.selectedJobIdentification = '';
    this.posted_Start = null;
    this.posted_End = null;
    this.deadLine_Start = '';
    this.deadLine_end = '';
    this.selectedStatus = [];
    this.tradeesChips = [];
    this.propertyChips = [];
    this.serviceTypesChips = [];
    this.selectedUrgency = this.urgencyTypes[0];
    this.selectedJobType = [];
    this.selectedJobType.push(this.jobTypes[1]);
    this.pageNumber = 1;
    this.pageSize = 20;
    this.scrolledTop = 0;
    this.isSnoozedJob = false;
  }

  public static getInstance(): AdvancedSearch {
    if (!AdvancedSearch.instance)
      AdvancedSearch.instance = new AdvancedSearch();
    return AdvancedSearch.instance;
  }

  public static clearInstance() {
    if (AdvancedSearch.instance) delete AdvancedSearch.instance;
  }
}
